import React from 'react';
import styled from 'styled-components';
import type { LessonStatus } from '../../../types/lesson';

type Props = {
  status?: LessonStatus | string; // union of known statuses + custom
  booked?: boolean;
  completed?: boolean;
  className?: string;
  children?: React.ReactNode;
};

const Pill = styled.span<{ $bg: string }>`
  font-weight: 800;
  font-size: 12px;
  padding: .25rem .5rem;
  border-radius: 999px;
  color: #fff;
  background: ${p => p.$bg};
`;

function computeBackground({ status, booked, completed }: Props): string {
  if (typeof completed === 'boolean' || typeof booked === 'boolean') {
    if (completed) return 'linear-gradient(135deg,#11998e,#38ef7d)';
    if (booked) return 'linear-gradient(135deg,#11998e,#38ef7d)';
    return 'linear-gradient(135deg,#667eea,#764ba2)';
  }
  const s = String(status || '').toLowerCase();
  if (s.includes('passed')) return 'linear-gradient(135deg, #4b5563, #6b7280)';
  // Make 'scheduled' look identical to 'completed' (same color and shape)
  if (s === 'completed' || s === 'scheduled') return 'linear-gradient(135deg,#11998e,#38ef7d)';
  if (s === 'available') return 'linear-gradient(135deg, #667eea, #764ba2)';
  if (['in_progress','booked'].includes(s)) return 'linear-gradient(135deg, #667eea, #764ba2)';
  if (s === 'cancelled') return 'linear-gradient(135deg, #fc4a1a, #f7b733)';
  return 'linear-gradient(135deg, #667eea, #764ba2)';
}

const StatusBadge: React.FC<Props> = ({ status, booked, completed, className, children }) => {
  const bg = computeBackground({ status, booked, completed });
  return (
    <Pill className={className} $bg={bg}>
      {children ?? (status ? String(status).toUpperCase() : null)}
    </Pill>
  );
};

export default StatusBadge;
